const TireIcon = ({ height = '50px', width = '50px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 50 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 6.83545C14.6613 6.83545 6.25 15.8205 6.25 26.8675C6.25 31.7392 7.89234 36.3674 10.8733 40.0147L11.21 40.4158H12.9925C13.3375 40.4158 13.6175 40.715 13.6175 41.0836C13.6175 41.4124 13.3963 41.6842 13.1048 41.7406L12.9925 41.7513H11.0925C10.4688 41.7513 9.9625 42.2935 9.9625 42.9586C9.9625 43.5725 10.3939 44.0806 10.9508 44.1551L11.0925 44.1645H38.9088C39.5325 44.1645 40.0387 43.6236 40.0387 42.9586C40.0387 42.3447 39.6074 41.8355 39.0504 41.7607L38.9088 41.7513H36.6C36.2538 41.7513 35.975 41.4535 35.975 41.0836C35.975 40.7559 36.1952 40.4832 36.4874 40.4266L36.6 40.4158H38.7913C41.9837 36.7099 43.75 31.9196 43.75 26.8675C43.75 15.8205 35.3387 6.83545 25 6.83545Z"
      fill="#515050"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 5.5C36.0275 5.5 45 15.086 45 26.8675C45 32.0224 43.2687 36.9169 40.1387 40.7938C40.825 41.2398 41.2887 42.0385 41.2887 42.9586C41.2887 44.2928 40.3205 45.3908 39.0945 45.4923L38.9088 45.5H11.0925C9.78 45.5 8.7125 44.3595 8.7125 42.9586C8.7125 42.0385 9.175 41.2398 9.86125 40.7938C6.73125 36.9156 5 32.0224 5 26.8675C5 15.086 13.9725 5.5 25 5.5Z"
      fill="#8F8FAB"
      stroke="#333333"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.9995 12.2454C32.562 12.2454 38.7157 18.8186 38.7157 26.8982C38.7157 34.9791 32.562 41.5536 24.9995 41.5536C17.4357 41.5536 11.2832 34.9791 11.2832 26.8982C11.2832 18.8186 17.4357 12.2454 24.9995 12.2454Z"
      fill="#222222"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.9995 13.5808C24.7978 13.5808 24.5989 13.5921 24.4006 13.6063L24.1032 13.6289V17.8062C24.1032 18.1294 23.887 18.4072 23.5882 18.4633C22.4332 18.6823 21.3645 19.1551 20.412 19.8669C20.3032 19.947 20.1782 19.9871 20.0545 19.9871C19.9335 19.9871 19.8133 19.9495 19.7096 19.8761L19.612 19.7907L16.852 16.8407C16.5126 17.1552 16.1901 17.4885 15.8845 17.8389L15.5845 18.1949L18.3457 21.1436C18.5595 21.3719 18.5895 21.7312 18.417 21.9969C17.7495 23.0186 17.3082 24.1604 17.1032 25.3917C17.0562 25.671 16.8522 25.8838 16.5993 25.9327L16.4882 25.9433H12.5782C12.557 26.2598 12.5332 26.5763 12.5332 26.8981C12.5332 27.1145 12.5438 27.3273 12.5571 27.5388L12.5782 27.8557H16.4882C16.7907 27.8557 17.0495 28.088 17.1032 28.4059C17.2945 29.5584 17.692 30.6294 18.2857 31.595C18.4279 31.8263 18.4198 32.1231 18.2757 32.344L18.2057 32.4336L15.4207 35.4091C15.7076 35.7777 16.017 36.1245 16.3409 36.4551L16.6695 36.7806L19.4132 33.8492C19.6332 33.6142 19.9807 33.5862 20.2282 33.7851C21.2332 34.5811 22.3632 35.1032 23.5882 35.3356C23.8496 35.3847 24.0479 35.6035 24.0933 35.874L24.1032 35.9927V40.17L24.6988 40.2107C24.7985 40.2153 24.8986 40.2181 24.9995 40.2181L25.3001 40.2107L25.8945 40.17V35.9927C25.8945 35.6695 26.112 35.3917 26.4107 35.3356C27.5645 35.1166 28.6332 34.6438 29.587 33.932C29.8024 33.7684 30.0887 33.7736 30.301 33.9313L30.387 34.0082L33.147 36.9569C33.4863 36.6434 33.8088 36.3103 34.1139 35.96L34.4132 35.604L31.6532 32.6553C31.4395 32.427 31.4095 32.0677 31.582 31.8006C32.2482 30.7803 32.6907 29.6385 32.8957 28.4059C32.9427 28.1278 33.1467 27.9151 33.3996 27.8663L33.5107 27.8557H37.4207C37.442 27.5391 37.4657 27.2226 37.4657 26.8981C37.4657 26.6836 37.4552 26.4714 37.4418 26.26L37.4207 25.9433H33.5107C33.2082 25.9433 32.9482 25.7109 32.8957 25.3917C32.6782 24.0829 32.1907 22.8757 31.4445 21.802C31.2826 21.5694 31.2815 21.2561 31.4311 21.0257L31.5045 20.9326L34.2482 17.9999C33.9482 17.6443 33.6348 17.3015 33.3034 16.9794L32.9657 16.6644L30.1795 19.6412C30.0595 19.7707 29.8995 19.8362 29.7382 19.8362C29.6182 19.8362 29.4995 19.8001 29.3945 19.7266C28.4895 19.0923 27.4857 18.6663 26.4107 18.4633C26.1493 18.4142 25.9501 18.1954 25.9044 17.925L25.8945 17.8062V13.6289C25.5982 13.6062 25.302 13.5808 24.9995 13.5808Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.8611 35.3369C29.1411 35.812 28.3696 36.1752 27.5546 36.4223L27.1436 36.5362V40.0071C28.8314 39.6925 30.4005 39.0188 31.7826 38.0569L32.1548 37.7875L29.8611 35.3369Z"
      fill="#B4CFEC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9305 35.1873L17.6455 37.6285C19.0343 38.718 20.6373 39.5068 22.3775 39.9074L22.8555 40.007V36.5348C21.9499 36.3046 21.0739 35.9241 20.2703 35.4138L19.9305 35.1873Z"
      fill="#B4CFEC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.2677 29.1911H34.019C33.824 30.0759 33.5197 30.9166 33.1101 31.7048L32.8965 32.0944L35.1902 34.545C36.139 33.1054 36.8241 31.4581 37.1791 29.6794L37.2677 29.1911Z"
      fill="#B4CFEC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.9809 29.1911H12.7334C13.0118 30.8969 13.5857 32.4945 14.409 33.9127L14.6634 34.3327L16.9746 31.862C16.5976 31.1687 16.3038 30.4318 16.0956 29.659L15.9809 29.1911Z"
      fill="#B4CFEC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8109 19.2525C13.861 20.6934 13.1768 22.3396 12.822 24.1192L12.7334 24.6078H15.9809C16.1759 23.7229 16.4811 22.8822 16.891 22.0941L17.1046 21.7045L14.8109 19.2525Z"
      fill="#B4CFEC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.0425 19.0402L32.7588 21.4814C33.2707 22.3181 33.6629 23.2366 33.9188 24.1948L34.02 24.6078H37.2688C36.9606 22.7225 36.2816 20.9764 35.3136 19.4508L35.0425 19.0402Z"
      fill="#B4CFEC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.854 13.7918C21.1674 14.1065 19.5973 14.7802 18.215 15.742L17.8428 16.0114L20.1378 18.462C20.8578 17.9869 21.6292 17.6237 22.4434 17.3766L22.854 17.2627V13.7918Z"
      fill="#B4CFEC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.1436 13.7918V17.2627C27.88 17.4475 28.5835 17.7249 29.2496 18.0929L29.6448 18.3244L31.9573 15.8538C30.663 14.9202 29.1951 14.2504 27.6194 13.8905L27.1436 13.7918Z"
      fill="#B4CFEC"
    />
    <ellipse cx="25" cy="26.1897" rx="6.25" ry="6.89655" fill="#333333" />
    <ellipse cx="25.001" cy="26.1897" rx="5" ry="5.51724" fill="#FCD385" />
  </svg>
);

export default TireIcon;
